module.exports = "img/flags/NP.e8691fb.png";